import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          تم التطوير بواسطة{' '}
          <a 
            href="https://oyounmedia.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            شركة عيون ميديا
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

